import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'COURSES_GET_ALL',
  GET_ALL_SUCCESS: 'COURSES_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'COURSES_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(() => `${BASE_URL}/courses/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});
